import { CUSTOM_ELEMENTS_SCHEMA, ChangeDetectorRef, Component, EventEmitter, Input, OnDestroy, Output, inject } from '@angular/core';
import { TranslocoModule } from '@ngneat/transloco';
import { ChartBindingDirective } from '@utils/chart-interactive/chart-controller.directive';
import { ChartTimeframes } from '@utils/chart-interactive/chart-timeframe-selector';
import { Subject } from 'rxjs';
import { SdModelDirective } from 'src/app/common/directives/sd-model.directive';

export enum SelectedTimeframe {
  '1M' = '1M',
  '1J' = '1J',
  '3J' = '3J',
  '5J' = '5J',
  '10J' = '10J',
  'Aufl.' = 'Aufl.',
  'YTD' = 'YTD',
}

@Component({
  selector: 'wct-time-frame-selection',
  standalone: true,
  imports: [TranslocoModule, SdModelDirective],
  templateUrl: './time-frame-selection.component.html',
  styleUrl: './time-frame-selection.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class TimeFrameSelectionComponent implements OnDestroy {
  @Input({ required: false }) public chartBinding?: ChartBindingDirective;
  @Input({ required: true }) public activeButtons: Partial<ChartTimeframes> = {};
  @Output() public timeframe$: Subject<SelectedTimeframe> = new EventEmitter();

  protected readonly buttons: ReadonlyArray<{ timeframe: SelectedTimeframe }> = [
    { timeframe: SelectedTimeframe.YTD },
    { timeframe: SelectedTimeframe['1M'] },
    { timeframe: SelectedTimeframe['1J'] },
    { timeframe: SelectedTimeframe['3J'] },
    { timeframe: SelectedTimeframe['5J'] },
    { timeframe: SelectedTimeframe['10J'] },
    { timeframe: SelectedTimeframe['Aufl.'] },
  ];

  protected currentlySelectedTimeframe: SelectedTimeframe = undefined;

  protected readonly SelectedTimeframe = SelectedTimeframe;

  private readonly cdr = inject(ChangeDetectorRef);

  ngOnDestroy(): void {
    this.timeframe$.complete();
  }

  public setSelection(timeframe: SelectedTimeframe): void {
    this.currentlySelectedTimeframe = timeframe;
    this.cdr.detectChanges();
  }

  public resetSelection(): void {
    this.currentlySelectedTimeframe = '' as SelectedTimeframe;
    this.cdr.detectChanges();
  }
}
